<template>
  <div v-if="deductionsPlanData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>{{ $t("deductions.code") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("actionDateTime") }}</th>
            <th>{{ $t("notes") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{{ isDataExist(deductionsPlanData.deductionsPlansCode) }}</th>
            <th>
              {{ isDataExist(deductionsPlanData.deductionsPlansNameCurrent) }}
            </th>
            <th>{{ timeToLang(deductionsPlanData.dateTimeActionAdd) }}</th>
            <th>{{ isDataExist(deductionsPlanData.deductionsPlansNote) }}</th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { timeToLang, isDataExist } from "@/utils/functions";

export default {
  name: "DeductionsPlanNameTable",
  data() {
    return {};
  },
  props: ["deductionsPlanData"],
  methods: {
    timeToLang(time) {
      return timeToLang(time, this.language);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
  },
  computed: {},
};
</script>

<style lang="scss"></style>
